import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MIcon from '../../../common/m-icon/MIcon';
import { logOut } from '@reducers/authSlice.js';
import { clearUser } from '@reducers/userSlice.js';
import { useLogoutUserMutation } from '@api/editorApi/AuthApi/AuthSerivce.js';
import { capitalize } from '@utils/general.js';
import ChooseRoleModal from '../modals/ChooseRoleModal.jsx';
import {RichTextEditor} from "@components/common/rich-text-editor/index.js";

function AuthPanel({ role, isOpen, setIsOpen }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();

    const [isChooseRoleModal, setIsChooseRoleModal] = useState(false);
    const [isClicked, setIsClicked] = useState(false);

    const menuRef = useRef(null);

    const user = useSelector((state) => state.user);
    const isAuth = useSelector(state => state.auth.isAuth);
    const token = useSelector(state=>state.auth.token);

    const [logout] = useLogoutUserMutation();

    const handleClick = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
            setIsClicked(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);
    }, []);

    return (
      <>

          {isAuth
            && (
              <div className={'flex relative'}>

                  <div className='flex flex-row items-center'>
                      <div className='flex items-center mr-2'>
                          <MIcon
                            type={'userCircle'}
                            className={`text-black cursor-pointer`} // ${!isOpen ? 'text-black' : 'text-main-color'}
                          />
                      </div>

                      <div className='flex flex-col'>
                          <div className={`text-black cursor-pointer`}
                          onClick={()=>{
                              navigate(`/settings`)
                          }}
                          >
                              {`${capitalize(user.last_name)} ${capitalize(user.first_name)}`}
                          </div>

                          <div className={`text-xs text-black`} // ${!isOpen ? 'text-black' : 'text-main-color'}
                             >
                              {t(`general.models.auth.roleType.${role}`)}
                          </div>
                      </div>

                      <div className='flex items-center ml-2 hover:cursor-pointer' onMouseDown={(e) => {
                          e.stopPropagation();
                          setIsClicked(prev => !prev);
                      }}>
                          {isClicked ? <MIcon
                              type={'arrowDown'}
                              className={`${isOpen ? 'text-blue3' : 'text-black'} rotate-180 `}
                            /> : (
                            <MIcon
                              type={'arrowDown'}
                              className={`text-black`} // ${!isOpen ? 'text-black' : 'text-main-color'}
                            />
                            )
                          }
                      </div>
                  </div>

                  <div
                    className={`${isClicked ? '' : 'hidden'} bg-superadmin p-3 right-0 rounded-lg absolute text-white ${isOpen ? 'top-[58px]' : 'top-[52px]'} z-40`}
                    ref={menuRef}>
                      <p
                        className='my-1 hover:cursor-pointer'
                      >
                          <Link
                            onClick={() => {
                                setIsOpen(false);
                                setIsClicked(false);
                            }}
                            className={'whitespace-nowrap'}
                            to='/settings'>
                              {t('general.header.settings')}
                          </Link>
                      </p>

                      <p
                        className='my-1 hover:cursor-pointer'
                      >
                          <Link
                            onClick={() => {
                                setIsOpen(false);
                                setIsClicked(false);
                            }}
                            className={'whitespace-nowrap'}
                            to='/change-password'>
                              {t('general.header.changePassword')}
                          </Link>
                      </p>

                      {user.roles.length > 1 && (
                        <p
                          className='my-1 hover:cursor-pointer'
                          onClick={() => {
                              setIsChooseRoleModal(prev => !prev);
                              setIsOpen(false);
                              setIsClicked(false);
                          }}
                        >
                            {t('general.header.role')}
                        </p>
                      )}

                      <p
                        className='my-1 hover:cursor-pointer' onClick={async () => {
                          setIsClicked(false);
                          const result = await logout({ access_token: token });
                          if (result.error){

                          } else {
                              dispatch(logOut());
                              dispatch(clearUser());
                              navigate('/');
                          }
                      }}>
                          {t('general.header.exit')}
                      </p>
                  </div>

                  <ChooseRoleModal
                    isChooseRoleModal={isChooseRoleModal}
                    setIsChooseRoleModal={setIsChooseRoleModal}
                  />

              </div>

            )
          }
          {/*<ChooseRoleModal*/}
              {/*  isChooseRoleModal={isChooseRoleModal}*/}
              {/*  setIsChooseRoleModal={setIsChooseRoleModal}*/}
              {/*  isAuth={isAuth}*/}
              {/*/>*/}

      </>
    );
}

export default memo(AuthPanel);
